import { Component } from "@angular/core";
import { FilterService } from "@progress/kendo-angular-grid";
import { CompositeFilterDescriptor, FilterDescriptor } from "@progress/kendo-data-query";
import { CustomRangeFilterCell } from '../../classes/custom-range-filter-cell';

@Component({
    selector: 'chassis-datatable-filter-row-date-range',
    templateUrl: './date-range.component.html',
    styleUrls: ['./date-range.component.scss'],
})
export class DateRangeComponent extends CustomRangeFilterCell {
    constructor(filterService: FilterService) {
        super(filterService);
    }

    /**
     * Get the start value
     *
     * @return {Date}
     */
    public get start(): Date {
        const first = this.findByOperator('gte');

        return (first || <FilterDescriptor>{}).value;
    }

    /**
     * Get the end value
     *
     * @return {Date}
     */
    public get end(): Date {
        const end = this.findByOperator('lte');
        return (end || <FilterDescriptor>{}).value;
    }

    /**
     * Filter on range
     *
     * @param {Date} start
     * @param {Date} end
     * @return void
     */
    public filterRange(start: Date, end: Date): void {
        this.filter = this.removeFilter(this.column.field);

        const filters = [];

        if (start) {
            filters.push({
                field: this.column.field,
                operator: 'gte',
                value: start
            });
        }

        if (end) {
            filters.push({
                field: this.column.field,
                operator: 'lte',
                value: end
            });
        }

        const root: CompositeFilterDescriptor = this.filter || {
            logic: 'and',
            filters: []
        };

        if (filters.length) {
            root.filters.push(...filters);
        }

        this.filterService.filter(root);
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-datatable/src/components/filters/row/date-range/date-range.component.ts